export default class JumpstartUnit {
  private unit: string;

  constructor(unit: string) {
    this.unit = unit;
  }

  private get adUnitIndex(): number {
    return this.unit.search(/\/[a-z/]+$/i);
  }

  get site(): string {
    if (this.adUnitIndex === -1) {
      return this.unit;
    }

    return this.unit.slice(0, this.adUnitIndex);
  }

  get adunit(): string {
    if (this.adUnitIndex === -1) {
      return '';
    }

    return this.unit.slice(this.adUnitIndex, this.unit.length);
  }
}
